import React from "react";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { useLocation, Link } from "react-router-dom";

const Question2 = ({ deleteStep , setAnswer2, addStep }) => {
  const answerHandler = (option) => {
    setAnswer2(option);
    addStep();
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
  
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            3 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--3 c-box2">
        <h1 className="c-question__title">髪の太さは？</h1>
        <section
          onClick={() => answerHandler("option1")}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>細い</p>
        </section>
        <section
          onClick={() => answerHandler("option2")}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>普通</p>
        </section>
        <section
          onClick={() => answerHandler("option3")}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>太い</p>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question2;
